import { gql } from '@apollo/client';
import { ProductTransactionFragments } from '../../../graphql/productTransaction.graphql';
import { ProductTransaction } from '../../productTransaction';

export namespace Elteros {
  export const companyId = 'c8ab03f6-1770-4104-a2cb-560ceeca429d';
  export const w2wStockLocationId = 'dee1f85f-0989-4652-a7f7-b13f3b3f0b41';

  export const perpardavimųSTOCKReorderRuleId = '3f7cd3d5-5add-4c6d-8dfa-ad0bea58583a';

  export const centrinisSandelisStockLocationId = '8bba4e9e-6936-4e36-8098-878d478396e0';
  export const centrinisSandelisTempStockLocationId = 'add4a123-33cd-4e01-a2d0-7b81db3cb767';
  export const perpard456StockLocationId = 'dee1f85f-0989-4652-a7f7-b13f3b3f0b41';

  export const projektasKodasCustomFieldId = '08281bc5-cab0-4a89-a0fa-9327969e5f10';
  export const salesOrderNoCustomFieldId = 'fa69dd7c-17b7-4b56-ab0a-958318691af5';

  export const stockReservation = gql`
    mutation StockReservation($salesOrder: String!) {
      stockReservation(salesOrder: $salesOrder) {
        ...ProductTransaction
      }
    }
    ${ProductTransactionFragments.productTransaction}
  `;

  export interface StockReservationVariables {
    salesOrder: string;
  }

  export interface StockReservationResponse {
    stockReservation: ProductTransaction[];
  }
}
